import { type ComponentProps, useEffect, useRef, useState } from 'react';

import { Tooltip } from '@iwoca/orion';

import { useMediaQuery } from '../../hooks/useMediaQuery';

type TooltipProps = ComponentProps<typeof Tooltip>;

export const TappableTooltip = (props: TooltipProps) => {
  const isTouchPrimary = useMediaQuery('(pointer:coarse)');
  const [open, setOpen] = useState(false);
  const wrapperRef = useRef<HTMLSpanElement>(null);

  useEffect(() => {
    if (!isTouchPrimary || !open) return;

    const onPointerDown = (e: PointerEvent) => {
      if (!wrapperRef.current?.contains(e.target as Node)) setOpen(false);
    };
    const onKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape') setOpen(false);
    };

    document.addEventListener('pointerdown', onPointerDown);
    document.addEventListener('keydown', onKeyDown);
    return () => {
      document.removeEventListener('pointerdown', onPointerDown);
      document.removeEventListener('keydown', onKeyDown);
    };
  }, [isTouchPrimary, open]);

  const toggle = () => setOpen((o) => !o);

  return isTouchPrimary ? (
    <span
      ref={wrapperRef}
      role="button"
      tabIndex={0}
      onClick={toggle}
      onKeyDown={(e) => (e.key === 'Enter' || e.key === ' ') && toggle()}
      className="inline-flex"
    >
      <Tooltip {...props} open={open} />
    </span>
  ) : (
    <Tooltip {...props} />
  );
};
